import ClickableMapBlock from './ClickableMapBlock';

export default ClickableMapBlock;
